import * as Sentry from "@sentry/react";
export const sentryErrorHandler = (e) => {
    Sentry.captureException(e);
    console.error(e);
};
export const setSentryContext = (data) => {
    if (data) {
        const { timezone, language, autologout, available } = data;
        Sentry.setContext("config", {
            timezone,
            language,
            autologout,
            available
        });
    }
    else {
        Sentry.setContext("config", null);
    }
};
//# sourceMappingURL=sentry-utils.js.map